import {TRIAL_ACCESS_AVAILABLE} from '@/store/getterTypes';
import {GET_USER_DATA} from '@/store/getterTypes';

export default {
  isLogged: (state) => {
    return Boolean(state.user);
  },
  [TRIAL_ACCESS_AVAILABLE]: (state) => {
    return !state.user?.trial_period_used;
  },
  [GET_USER_DATA](state) {
    return state.user;
  },
};

